//to use french for moment locale
import 'moment/locale/fr';
import 'react-calendar-timeline/lib/Timeline.css';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
    Autocomplete,
    Button,
    Grid,
    IconButton,
    TextField,
} from '@mui/material';
// make sure you include the timeline stylesheet or the timeline will not be styled
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Timeline, {
    DateHeader,
    SidebarHeader,
    TimelineHeaders,
    // CustomHeader,
} from 'react-calendar-timeline/lib';
import { useTranslation } from 'react-i18next';

import { fetchMissionExperts } from '../../Api/suiviMission/experts';
// import Status from "./Status";
import { updateTask } from '../../Api/suiviMission/tasks';
import { useGlobalContext } from '../../Contexts/suiviMission/GlobalContext';
import { useTaskContext } from '../../Contexts/suiviMission/TaskContext';

// const visibleTimeStart = moment().startOf("day").valueOf();
// const visibleTimeEnd = moment().startOf("day").add(30, "day").valueOf();
const Cal = () => {
    const { tasks
        // , setTasks
    } = useTaskContext();
    // const [step, setstep] = useState(7);
    const { mission } = useGlobalContext();
    const { i18n } = useTranslation();
    const itemat = tasks
        // .filter((t) => t.dateDebut && t.dateFin)
        .map((task) => {
            const st = task.dateDebut
                ? moment(new Date(task.dateDebut)).valueOf()
                : null;
            // const en = task.dateFin
            //   ? moment(new Date(task.dateFin)).valueOf()
            //   : moment(new Date(task.dateDebut)).add(1, "day").valueOf();
            var endless = false;

            const e = () => {
                if (task.dateFin) return moment(new Date(task.dateFin)).valueOf();
                endless = true;
                return moment(new Date(task.dateDebut)).add(1, 'day').valueOf();
            };
            return {
                id: task._id,
                group: task._id,
                title: task.title,
                start_time: st,
                end_time: e(),
                Endless: endless,
                itemProps: {
                    style: {
                        backgroundColor:
                            task.status === 'in progress'
                                ? '#F6ADD1'
                                : task.status === 'done'
                                    ? '#7BCDC0'
                                    : task.status === 'to do'
                                        ? '#4A90E2'
                                        : '#4A90E2',
                        borderColor: '',
                    },
                },
            };
        });
    const [itemss, setitemss] = useState(itemat);

    useEffect(() => {
        // ! detect language from Browser Preferences
        var userLang = navigator.language || navigator.userLanguage;
        moment.locale(userLang);
        console.log(itemat);
    });

    useEffect(() => {
        console.log(tasks);
    }, [tasks]);

    const [visibleTimeStart, setvisibleTimeStart] = useState(
        moment().startOf('day').add(-1, 'day').valueOf()
    );
    const [visibleTimeEnd, setvisibleTimeEnd] = useState(
        moment().startOf('day').add(7, 'day').valueOf()
    );

    const onPrevClick = () => {
        const zoom = visibleTimeEnd - visibleTimeStart;
        setvisibleTimeStart(visibleTimeStart - zoom);
        setvisibleTimeEnd(visibleTimeEnd - zoom);
    };
    const onNextClick = () => {
        const zoom = visibleTimeEnd - visibleTimeStart;
        setvisibleTimeStart(visibleTimeStart + zoom);
        setvisibleTimeEnd(visibleTimeEnd + zoom);
    };
    const onItemDoubleClick = (itemId, e, time) => {
        console.log(itemId);
        console.log(e);
        console.log(time);
        //show task info
    };
    const handleResize = (itemId, time, edge) => {
        console.log(time);
        console.log(itemId);
        console.log(edge);
        //const item = itemat.find((data) => data.id === itemId);
        if (edge === 'left') {
            //handle change start date
            //  item.start_time = time;
            setitemss(
                itemss.map((e) => {
                    if (e.id === itemId) {
                        return {
                            id: e.id,
                            group: e.id,
                            title: e.title,
                            start_time: time,
                            end_time: e.end_time,
                            itemProps: e.itemProps,

                        };
                    }
                    return e;
                })
            );

            //make api call
            updateTask(itemId, { dateDebut: moment(time).toDate() });

            //show confirmation msg?
        } else {
            //handle change end date (edge === 'right')
            setitemss(
                itemss.map((e) => {
                    if (e.id === itemId) {
                        return {
                            id: e.id,
                            group: e.id,
                            title: e.title,
                            start_time: e.start_time,
                            end_time: time,
                            itemProps: e.itemProps,
                            Endless: false,
                        };
                    }
                    return e;
                })
            );
            //make api call

            updateTask(itemId, { dateFin: moment(time).toDate() });

            //show confirmation msg?
        }
    };

    const defaultGroups = tasks
        // .filter((t) => t.dateDebut && t.dateFin)
        .map((task) => {
            return {
                title: task.title,
                id: task._id,
                status: task.status,
            };
        });
    const [groups, setgroups] = useState(defaultGroups);

    //   const items = [
    //     {
    //       id: 1,
    //       group: 1,
    //       title: "item 1",
    //       start_time: moment(),
    //       end_time: moment().add(4, "day"),
    //     },
    //     {
    //       id: 2,
    //       group: 2,
    //       title: "item 2",
    //       start_time: moment().add(-0.5, "day"),
    //       end_time: moment().add(0.5, "day"),
    //     },
    //     {
    //       id: 3,
    //       group: 1,
    //       title: "item 3",
    //       start_time: moment().add(2, "day"),
    //       end_time: moment().add(9, "day"),
    //     },
    //   ];
    const [timeSteps, settimeSteps] = useState({
        second: 0,
        minute: 0,
        hour: 0,
        day: 1,
        month: 1,
        year: 1,
    });
    const [labelFormat, setlabelFormat] = useState('dddd DD/MM');

    const handleToday = () => {
        setvisibleTimeStart(moment().startOf('day').valueOf());
        setvisibleTimeEnd(moment().startOf('day').add(1, 'day').valueOf());
        settimeSteps({
            second: 0,
            minute: 0,
            hour: 1,
            day: 1,
            month: 1,
            year: 1,
        });
        setlabelFormat('HH:mm');
    };

    const handleWeek = () => {
        setvisibleTimeEnd(moment().startOf('day').add(9, 'day').valueOf());
        settimeSteps({
            second: 0,
            minute: 0,
            hour: 0,
            day: 1,
            month: 1,
            year: 1,
        });
        setlabelFormat('dddd DD/MM');
    };
    const handleMonth = () => {
        setvisibleTimeEnd(moment().startOf('day').add(50, 'day').valueOf());
        settimeSteps({
            second: 0,
            minute: 0,
            hour: 0,
            day: 1,
            month: 1,
            year: 1,
        });
        setlabelFormat('DD');
    };
    const [responsableOptions, setresponsableOptions] = useState([]);
    useEffect(() => {
        fetchMissionExperts(setresponsableOptions, mission._id);
    }, []);
    const handleChange = (event, value, reason) => {
        if (reason === 'clear') {
            setitemss(itemat);
            setgroups(defaultGroups);
        } else {
            console.log(event, value);

            const items = tasks
                .filter(
                    (t) =>
                        t.expertId.map((e) => e._id).includes(value._id) &&
                        t.dateDebut &&
                        t.dateFin
                )
                .map((task) => {
                    const st = task.dateDebut
                        ? moment(new Date(task.dateDebut)).valueOf()
                        : null;
                    // const en = task.dateFin
                    //   ? moment(new Date(task.dateFin)).valueOf()
                    //   : moment(new Date(task.dateDebut)).add(1, "day").valueOf();
                    var endless = false;

                    const e = () => {
                        if (task.dateFin) return moment(new Date(task.dateFin)).valueOf();
                        endless = true;
                        return moment(new Date(task.dateDebut)).add(1, 'day').valueOf();
                    };
                    return {
                        id: task._id,
                        group: task._id,
                        title: task.title,
                        start_time: st,
                        end_time: e(),
                        Endless: endless,
                        itemProps: {
                            style: {
                                backgroundColor:
                                    task.status === 'in progress'
                                        ? '#F6ADD1'
                                        : task.status === 'done'
                                            ? '#7BCDC0'
                                            : task.status === 'to do'
                                                ? '#4A90E2'
                                                : '#4A90E2',
                                borderColor: '',
                            },
                        },
                    };
                });
            const groups = tasks
                .filter(
                    (t) =>
                        t.expertId.map((e) => e._id).includes(value._id) &&
                        t.dateDebut &&
                        t.dateFin
                )
                .map((task) => {
                    return {
                        title: task.title,
                        id: task._id,
                        status: task.status,
                    };
                });
            //handle display
            setitemss(items);
            setgroups(groups);
        }
    };

    return (
        <div>
            <Grid
                container
                className="pb-3"
                alignItems="center"
            >
                <Grid
                    item
                    xs={2}
                >
                    <IconButton
                        onClick={onPrevClick}
                        aria-label="previous"
                    >
                        <ArrowBackIosIcon />
                    </IconButton>
                    <IconButton
                        onClick={onNextClick}
                        aria-label="next"
                    >
                        <ArrowForwardIosIcon />
                    </IconButton>
                </Grid>
                <Grid
                    container
                    xs={6}
                    justifyContent="end"
                >
                    <Autocomplete
                        onChange={handleChange}
                        disablePortal
                        id="combo-box-demo"
                        getOptionLabel={(option) => {
                            return (
                                option.persoData?.nom +
                                ' ' +
                                option.persoData?.prenom
                            );
                        }}
                        options={responsableOptions}
                        size="small"
                        sx={{ width: 200, marginRight: '10px' }}
                        renderOption={(props, option) => {
                            return (
                                <li
                                    {...props}
                                    key={option._id}
                                >
                                    {option.persoData?.nom +
                                        ' ' +
                                        option.persoData?.prenom}
                                </li>
                            );
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={i18n.t('Responsable')}
                            />
                        )}
                    />
                </Grid>
                <Grid
                    item
                    xs={4}
                >
                    <Button
                        variant="contained"
                        sx={{ marginRight: '3px', backgroundColor: '#19223F' }}
                        onClick={handleToday}
                    >
                        {i18n.t('Aujourd hui')}
                    </Button>

                    <Button
                        variant="contained"
                        sx={{ marginRight: '3px', backgroundColor: '#19223F' }}
                        onClick={handleWeek}
                    >
                        {i18n.t('Semaine')}
                    </Button>
                    <Button
                        variant="contained"
                        sx={{ marginRight: '3px', backgroundColor: '#19223F' }}
                        onClick={handleMonth}
                    >
                        {i18n.t('Mois')}
                    </Button>
                </Grid>
            </Grid>

            {/* <Button onClick={()=>{console.log(itemat)}}>next</Button> */}

            <Timeline
                groups={groups}
                items={itemss}
                visibleTimeStart={visibleTimeStart}
                visibleTimeEnd={visibleTimeEnd}
                buffer={1}
                onItemDrag={(itemDragObject) => {
                    console.log(itemDragObject);
                }}
                onItemDoubleClick={onItemDoubleClick}
                //   traditionalZoom={true}
                canResize={'both'}
                itemTouchSendsClick={true}
                itemRenderer={({ item, itemContext, getItemProps, getResizeProps }) => {
                    const { left: leftResizeProps, right: rightResizeProps } =
                        getResizeProps();
                    return (
                        <div {...getItemProps(item.itemProps)}>
                            {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : ''}
                            {item.Endless === false ? (
                                <div
                                    className="rct-item-content"
                                    style={{ maxHeight: `${itemContext.dimensions.height}` }}
                                >
                                    {itemContext.title}
                                </div>
                            ) : (
                                <div
                                    style={{
                                        position: 'sticky',
                                        // position: "-webkit-sticky",
                                        left: '0px',
                                        overflow: 'hidden',
                                        display: 'inline-block',
                                        borderRadius: '2px',
                                        padding: ' 0 6px',
                                        height: '100%',
                                        width: '100%',
                                        maxHeight: `${itemContext.dimensions.height}`,
                                        // background: ` ${item.itemProps.style.backgroundColor}`,
                                        background:
                                            `linear-gradient(90deg,  ${item.itemProps.style.backgroundColor} 0%, ${item.itemProps.style.backgroundColor} 50%, rgba(242, 242, 242) 100%)`,
                                    }}
                                // style={{ maxHeight: `${itemContext.dimensions.height}` }}
                                >
                                    {itemContext.title}
                                </div>
                            )}
                            {/* <button onClick={console.log(itemContext)}>log</button> */}
                            {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : ''}
                        </div>
                    );
                }}
                // verticalLineClassNamesForTime ={()=>{
                //     return ["bg-dark"]
                // }}
                // onItemMove={(itemId, dragTime, newGroupOrder) => {
                //   console.log(newGroupOrder);
                //   console.log(dragTime);
                //   console.log(itemId);
                //   console.log(moment().add(-0.5, "day").valueOf());
                // }}
                onItemResize={handleResize}
                stackItems={true}
                lineHeight={50}
                itemHeightRatio={0.6}
                timeSteps={timeSteps}
                groupRenderer={({ group }) => {
                    return (
                        <div
                            className="text-center "
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <span
                                className="fw-bold "
                                style={{ fontSize: 14 }}
                            >
                                {group.title}
                            </span>
                            <div
                                className="fw-bold "
                                style={{
                                    backgroundColor:
                                        group.status === 'in progress'
                                            ? '#F6ADD1'
                                            : group.status === 'done'
                                                ? '#7BCDC0'
                                                : group.status === 'to do'
                                                    ? '#4A90E2'
                                                    : '#4A90E2',
                                    width: 'fit-content',
                                    height: '24px',
                                    lineHeight: '30px',
                                    padding: '0px 5px',
                                    margin: '3px',
                                    borderRadius: '1px',
                                    fontSize: 12,
                                    textAlign: 'center',
                                    opacity: '50%',
                                }}
                            >
                                {group.status}
                            </div>
                            {/* <p className="tip">{group.tip}</p> */}
                        </div>
                    );
                }}
            >
                <TimelineHeaders style={{ backgroundColor: '#19223F' }}>
                    <SidebarHeader>
                        {({ getRootProps }) => {
                            return <div {...getRootProps()}></div>;
                        }}
                    </SidebarHeader>
                    <DateHeader unit="primaryHeader" />

                    <DateHeader labelFormat={labelFormat} />
                </TimelineHeaders>
            </Timeline>
        </div>
    );
};

export default Cal;
